import { useEffect } from 'react';

import { useNavigation } from '@/context/NavigationContext';
import { resolvePortalHomeRoute } from '@/lib/account-routing';

export default function PortalLandingRedirectPage() {
  const navigation = useNavigation();
  const target = resolvePortalHomeRoute();

  useEffect(() => {
    navigation.navigate(target, { replace: true });
  }, [navigation, target]);

  return null;
}
